import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ReCaptcha = ({ getCaptcha }) => {
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
    getCaptcha(value);
  };



  return (
    <ReCAPTCHA
      sitekey={process.env.REACT_APP_SITEKEY}
      onChange={handleRecaptchaChange}
    />
  );
};
export default ReCaptcha;
